// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MODE_UPPER, MODE_LOWER } from '../../IndicatorConstants';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iEnvelopes = 'iEnvelopes';
export class IEnvelopes extends iBuildInIndicator {
    constructor(maPeriod, maMethod, maShift, deviation, priceType) {
        super(3);
        this.ma = new ExpandDoubleVector();
        this.FPriceType = priceType;
        this.FMaPeriod = maPeriod;
        this.FMaMethod = maMethod;
        this.FDeviation = deviation;
        this.FData.FArray[0].FShift = maShift;
        this.FData.FArray[1].FShift = maShift;
        this.FData.FArray[2].FShift = maShift;
    }
    get Name() {
        return iEnvelopes;
    }
    get Key() {
        return this.DefaultKey + this.MaPeriod + this.MaMethod + this.Deviation + this.FPriceType;
    }
    NextBar(callBound) {
        super.NextBar(callBound);
        this.ma.Add(0.0);
    }
    Refresh(count, newThread) {
        this.ma.Dispose();
        this.ma = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    OnQuote() {
        const price = this.GetPrice(this.FPriceType, 0);
        this.ma[this.ma.Length - 1] = price;
        const Parent = this.Parent;
        if (!Parent || this.FCount < this.FMaPeriod || this.FMaPeriod == 0) {
            return;
        }
        const maValue = IndicatorFunctions.CallMovingFunction(this.FMaMethod, this.ma, this.FMaPeriod, 1);
        // Setting value
        this.SetValue(MODE_UPPER, 0, (1.0 + this.FDeviation * 0.01) * maValue);
        this.SetValue(MODE_LOWER, 0, (1.0 - this.FDeviation * 0.01) * maValue);
        this.SetValue(2, 0, maValue);
    }
}
